import {
  isDingtalk,
  isFeishu,
  isIOS,
  isIos13,
  isIpad,
  isMobileByUA,
  isQQInsideBrowser,
  isSafari,
  isWechat,
  isWorkWeixin,
} from './checkUA';

const isFocusLoginInput = () => {
  const el = document.activeElement as HTMLElement;
  const codeInputEl = document.querySelector('.code-input') as HTMLInputElement;
  if (codeInputEl && codeInputEl.contains(el)) {
    return true;
  }
  const phoneInputEl = document.querySelector('.phone-input') as HTMLInputElement;
  if (phoneInputEl && phoneInputEl.contains(el)) {
    return true;
  }
  return false;
};

export function fixVhHeightInSafari() {
  const handle = () => {
    document.documentElement.style.setProperty('--screen', `${window.innerHeight}px`);
    document.documentElement.style.setProperty(
      '--contact-modal',
      `${Math.max((window.innerHeight - 637) / 2, 50)}px`,
    );
  };
  const handleResize = () => {
    // 关闭软键盘,为了避免误伤，只针对此种情况做处理
    if (isMobileByUA && isIpad) {
      if (!isFocusLoginInput()) {
        closeSoftKeyboard();
      }
    }
    handle();
    setTimeout(() => {
      handle();
      // 视窗更新了，但是滚动条位置没有更新，导致页面错位
      if (isMobileByUA && isIpad && !isFocusLoginInput()) {
        window.scrollTo(0, 0);
      }
    }, 200);
  };
  handleResize();
  window.addEventListener('resize', handleResize, { passive: true });
}

export function fixOnVisibilityChange() {
  if (!(isIpad || isIos13)) return;
  // ios ipad  会在切换到后台时，收起软键盘，不然会出问题。
  // 为了避免误伤，只针对此种情况做处理

  if (isIpad) {
    window.addEventListener(
      'visibilitychange',
      () => {
        if (isIpad && document.visibilityState === 'visible') {
          setTimeout(() => {
            closeSoftKeyboard();
          }, 100);
        }
      },
      { passive: true },
    );
  }

  // 为了不影响之前写的ipad 所以没有合并写
  // isIos13 老手机 只能 document.addEventListener 监听。。。，window.addEventListener不生效
  if (isIos13) {
    document.addEventListener('visibilitychange', () => {
      if (isIos13 && document.visibilityState === 'visible') {
        setTimeout(() => {
          closeSoftKeyboard();
        }, 100);
      }
    });
  }
}

export function disableScaleEventIOS() {
  if (!isIOS) return;
  // ios 禁止缩放页面
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
}

export function isWhiteList() {
  // 是不是满足条件
  const isWhiteListBrowser =
    isWechat || isFeishu || isDingtalk || isWorkWeixin || isQQInsideBrowser;
  return isMobileByUA && isWhiteListBrowser;
}

// 修复应用内置浏览器时底部区域过小的问题
export function fixBottomInAppBrowser() {
  if (isWhiteList()) {
    const el = document.querySelector('.input-wrapper-mobile');
    el?.classList.add('white-list');
  }
}

export const clearSafariScrollingState = (el: HTMLElement | null) => {
  if (!el) return;
  if (isIOS || isSafari) {
    // ios 正在滚动时，如果点击新建对话，因为滚动惯性会白屏。
    // 此时禁用滚动。
    if (el) el.style.overflowY = 'hidden';
    setTimeout(() => {
      // 路由切换完再搞回去
      if (el) el.style.overflowY = 'auto';
    }, 100);
  }
};

export const closeSoftKeyboard = () => {
  (document.activeElement as HTMLElement)?.blur(); // 收起软键盘
};

export const fixOnBlur = () => {
  if (!isMobileByUA) return;
  setTimeout(() => {
    window.dispatchEvent(new Event('resize')); // 触发resize事件
  }, 200);
};
